import { patchSetSelectedPaymentIntent, PaymentIntent } from '@nemuru-eng/js-api-client';

import { CheckoutSessionEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/entities/CheckoutSessionEntity';
import { useCheckoutSession } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSession';
import { useMutation } from '@/hooks/useMutation';

export const useSetSelectedPaymentIntentMutation = (
  paymentIntent: PaymentIntent,
  checkoutSessionEntity: CheckoutSessionEntity,
) => {
  const { refreshCheckoutSessionAndPaymentMethodEntities } = useCheckoutSession();

  return useMutation({
    mutationFn: async () => {
      if (!checkoutSessionEntity) {
        throw new Error('Checkout session entity not found');
      }

      const clientSecret = await checkoutSessionEntity?.getClientSecret();

      if (!clientSecret) {
        throw new Error('Client secret not found');
      }

      await patchSetSelectedPaymentIntent({
        id: checkoutSessionEntity.id,
        paymentMethodType: paymentIntent.paymentMethodType,
        paymentMethodId: paymentIntent.paymentMethodId,
        clientSecret,
      });

      await refreshCheckoutSessionAndPaymentMethodEntities();
    },
  });
};
